// Only use for internal calls! This should not be used for any public facing requests. Tells Imperva to ignore the request.
const fsOperationsCallHeader = { fs_operations_call: 'fs-lightyear' }

export default fsOperationsCallHeader
